import { createSlice } from '@reduxjs/toolkit';
import { OVERVIEW_TAB } from '../../../../../apps/emergency_data/src/constants/eventPaneTabs';

const initialState = {
  selectedTab: OVERVIEW_TAB,
  selectedTool: null,
  chatVisibility: {
    isAgencyShareChatVisible: true,
    isTextFrom911ChatVisible: true,
    isRcsChatVisible: true,
    isConversationsChatVisible: true,
    isCollaboratorChatVisible: true,
  },
};

const eventPaneSlice = createSlice({
  name: 'eventPane',
  initialState,
  reducers: {
    setSelectedTab: (state, action) => {
      state.selectedTab = action.payload;
    },
    setSelectedTool: (state, action) => {
      state.selectedTool = action.payload;
    },
    setChatVisibility: (state, action) => {
      const { chatType, isVisible } = action.payload;
      state.chatVisibility[chatType] = isVisible;
    },
    resetState: () => initialState,
  },
});

export const {
  setSelectedTab,
  setSelectedTool,
  setChatVisibility,
  resetState,
} = eventPaneSlice.actions;
export default eventPaneSlice.reducer;
